import { useMutation } from 'data-fetching-client';
import { updateUserPropertiesMutation } from '../api/userObject.queries';
import { getCrmObjectByUserIdQuery } from './useUserPropertyValue';
import { HS_AWAY_STATUS_TIMER } from '../constants';
import { useCallback } from 'react';
import { useAwayStatusTimer } from './useAwayStatusTimer';
export const useClearAwayStatusTimer = userId => {
  const [updateProperty] = useMutation(updateUserPropertiesMutation, {
    refetchQueries: [getCrmObjectByUserIdQuery],
    awaitRefetchQueries: true
  });
  const {
    awayStatusTimer
  } = useAwayStatusTimer(userId, {
    isViewingSelf: true
  });
  return useCallback(isAvailable => {
    if (awayStatusTimer && isAvailable) {
      void updateProperty({
        variables: {
          userId,
          isViewingSelf: true,
          userProperties: {
            [HS_AWAY_STATUS_TIMER]: ''
          }
        }
      });
    }
  }, [awayStatusTimer, updateProperty, userId]);
};